/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactWithRelations } from '../../models/contact-with-relations';

export interface InventoryCreateContact$Params {
  inventoryId: string;
      body?: ContactWithRelations
}

export function inventoryCreateContact(http: HttpClient, rootUrl: string, params: InventoryCreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactWithRelations>> {
  const rb = new RequestBuilder(rootUrl, inventoryCreateContact.PATH, 'post');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactWithRelations>;
    })
  );
}

inventoryCreateContact.PATH = '/inventory/contacts';
